import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';

import type {
  FailedPaymentsResponse,
  FetchFailedPaymentsParams,
} from './types';

export const fetchFailedPaymentsAPI = async (
  params: FetchFailedPaymentsParams,
): Promise<FailedPaymentsResponse> => {
  const { page = 1, limit = 10, startDate, endDate, search } = params;

  const response = await baseAPI.get<FailedPaymentsResponse>(
    'subscription-invoices/fetch-failed-payments',
    {
      params: {
        page,
        limit,
        startDate,
        endDate,
        search,
      },
    },
  );

  return response.data;
};

export const downloadFailedPaymentsCSVAPI = async (params: {
  startDate: string;
  endDate: string;
  page?: number;
  limit?: number;
  search?: string;
}): Promise<Blob> => {
  const { page = 1, limit = 1000, startDate, endDate, search } = params;

  const response = await baseAPI.get(
    'subscription-invoices/fetch-failed-payments',
    {
      params: {
        page,
        limit,
        startDate,
        endDate,
        search,
        csv: true,
      },
      responseType: 'blob',
    },
  );

  return response.data as Blob;
};

export const useFetchFailedPayments = (
  params: FetchFailedPaymentsParams,
  options?: { enabled?: boolean },
) => {
  return useQuery({
    queryKey: QUERY_KEYS.FAILED_PAYMENTS(params),
    queryFn: () => fetchFailedPaymentsAPI(params),
    enabled:
      (options?.enabled ?? true) && !!params.startDate && !!params.endDate,
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
};
